import { NeuCard } from "../../components/neu/Neu";

// خرائط الألوان — لازمة عشان Tailwind JIT يلتقط الكلاسات (لا يعمل مع string interpolation).
const TONES = {
  primary: {
    bg: "bg-gradient-to-br from-primary/5 via-transparent to-primary/10",
    icon: "bg-primary/15 text-primary",
    ring: "ring-1 ring-primary/20",
  },
  indigo: {
    bg: "bg-gradient-to-br from-indigo-500/5 via-transparent to-indigo-500/10",
    icon: "bg-indigo-500/15 text-indigo-600 dark:text-indigo-300",
    ring: "ring-1 ring-indigo-500/20",
  },
  amber: {
    bg: "bg-gradient-to-br from-amber-500/5 via-transparent to-amber-500/10",
    icon: "bg-amber-500/15 text-amber-600 dark:text-amber-300",
    ring: "ring-1 ring-amber-500/20",
  },
  emerald: {
    bg: "bg-gradient-to-br from-emerald-500/5 via-transparent to-emerald-500/10",
    icon: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-300",
    ring: "ring-1 ring-emerald-500/20",
  },
  sky: {
    bg: "bg-gradient-to-br from-sky-500/5 via-transparent to-sky-500/10",
    icon: "bg-sky-500/15 text-sky-600 dark:text-sky-300",
    ring: "ring-1 ring-sky-500/20",
  },
};

export const cardTone = (tone) => TONES[tone] || TONES.primary;

// رأس قسم/كارت: أيقونة + عنوان + شرح — قابل للاستخدام مع تصميم موحّد.
export const CardHeader = ({ icon: Icon, tone = "primary", title, hint, right }) => {
  const c = cardTone(tone);
  return (
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div className="flex items-start gap-3">
        <div className={`grid h-11 w-11 place-items-center rounded-2xl shadow-neu-in ${c.icon}`}>
          <Icon className="h-5 w-5" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-base font-black text-foreground">{title}</p>
          {hint ? <p className="mt-1 text-xs text-muted-foreground">{hint}</p> : null}
        </div>
      </div>
      {right}
    </div>
  );
};

// كارت مُلوّن ناعم بلمسة gradient — يُغلّف NeuCard.
export const ToneCard = ({ tone = "primary", className = "", children, testId }) => {
  const c = cardTone(tone);
  return (
    <NeuCard className={`${c.bg} ${c.ring} ${className}`} data-testid={testId}>
      {children}
    </NeuCard>
  );
};
